import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import Icon, { ICON_SIZE_REGULAR } from '@divvy-web/skylab.icon'
import TextLink, { TextLinkSizes } from '@divvy-web/skylab.textlink'

import styles from './styles.module.scss'
interface AgreementLinkProps {
  hasAgreedToTila: boolean
  onClick: () => void
}

const AgreementLink = ({ hasAgreedToTila, onClick }: AgreementLinkProps) => {
  const [getClassName] = useNameFormatter('AgreementLink')

  if (!hasAgreedToTila) {
    return (
      <div className={`${styles[getClassName('')]} dd-privacy-allow`}>
        <Icon
          className={styles[getClassName('icon')]}
          name='feedbackInProcess'
          size={ICON_SIZE_REGULAR}
        />
        <TextLink
          size={TextLinkSizes.REGULAR}
          onClick={onClick}
        >
          <FormattedMessage
            defaultMessage='Review and agree to the offer summary'
            id='sputnik.AgreementLink__kVthTf'
          />
        </TextLink>
      </div>
    )
  }

  return (
    <div className={`${styles[getClassName('')]} dd-privacy-allow`}>
      <Icon
        className={styles[getClassName('icon')]}
        name='feedbackSuccess'
        size={ICON_SIZE_REGULAR}
      />
      <TextLink
        size={TextLinkSizes.REGULAR}
        onClick={onClick}
      >
        <FormattedMessage
          defaultMessage='View offer summary'
          id='sputnik.AgreementLink__TM3TcF'
        />
      </TextLink>
    </div>
  )
}

export default AgreementLink
